// client/src/components/Admin/PlanesEducaCmp/_shared/PlanCardSkeleton.js
//
// M07 - Esqueleto del PlanCard mientras carga. Mantiene la misma forma
// (cover + body + kpis) para evitar layout shift al recibir los datos.

import React from "react";
import styles from "./PlanCardSkeleton.module.scss";

export function PlanCardSkeleton() {
  return (
    <div className={styles.skeletonCard} aria-hidden>
      <div className={styles.cover} />
      <div className={styles.body}>
        <div className={`${styles.line} ${styles.titleLine}`} />
        <div className={styles.line} />
        <div className={`${styles.line} ${styles.metaLine}`} />
        <div className={styles.kpiRow}>
          <div className={styles.kpi} />
          <div className={styles.kpi} />
          <div className={styles.kpi} />
        </div>
        <div className={styles.line} />
      </div>
    </div>
  );
}
